<template>
    <div id="profile-settings-container">
        <div class="container card p-5 shadow">
            <h1>{{$t('PROFILE_SETTINGS')}}</h1>
            <div class="row mb-2 w-100">
                <b-tabs v-model="tabIndex" class="w-100">
                    <b-tab title="Profile" href="#profile">
                        <div class="py-4">
                            <edit-profile></edit-profile>
                        </div>
                    </b-tab>
                    <b-tab title="Change Password" href="#change-password">
                        <div class="py-4">
                            <change-password-settings></change-password-settings>
                        </div>
                    </b-tab>
                    <b-tab title="Two Factor Authentication" href="#two-factor">
                        <div class="py-4">
                            <two-factor-settings></two-factor-settings>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
    </div>
</template>

<script>import TwoFactorAuthenticationSettings from './TwoFactorAuthenticationSettings';
    import ChangePasswordSettings from './ChangePasswordSettings';
    import ProfileEdit from './ProfileEdit';
    export default {
        components: {
            'two-factor-settings': TwoFactorAuthenticationSettings,
            'change-password-settings': ChangePasswordSettings,
            'edit-profile': ProfileEdit

        },
        data() {
            return {
                tabIndex: 0,
                tabs: ['#profile', '#change-password', '#two-factor']
            }
        },
        methods: {

        },
        mounted: function () {
            this.tabIndex = this.tabs.findIndex(tab => tab === this.$route.hash)
        }
    }</script>

<style lang="scss" scoped>
    #profile-settings-container {
        .container {
            border: none;
            border-radius: 0px;
        }
    }
</style>
